module.exports = __webpack_public_path__ + "static/media/Accident.1b7b3d8b.svg";